export default "__VITE_ASSET__BNFwHvVb__"